<div *ngIf="dateInputForm" class="date-input-search" [formGroup]="dateInputForm">
  <mat-form-field>
    <input
      type="text"
      matInput
      class="date-input-search__input"
      [placeholder]="field.placeholder"
      [attr.aria-label]="field.ariaLabel"
      [style.width]="(field.percentageWidth ? field.percentageWidth : '80') + '%'"
      [formControlName]="field.name"
      [matDatepicker]="datePicker"
    />

    <mat-datepicker-toggle matSuffix [for]="datePicker">
      <mat-icon
        class="date-input-search__icon"
        matDatepickerToggleIcon
        svgIcon="calendar"
        role="presentation"
      ></mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker-toggle
      class="date-input-search__datepicker-clear"
      [aria-label]="'Suppression du filtre ' + field.ariaLabel | lowercase | upperfirst"
      *ngIf="!!value"
      matSuffix
      (click)="clearValue($event)"
    >
      <mat-icon matDatepickerToggleIcon svgIcon="cross" role="presentation"></mat-icon>
    </mat-datepicker-toggle>

    <mat-datepicker
      #datePicker
      startView="year"
      (opened)="isPanelOpen.emit(true)"
      (closed)="isPanelOpen.emit(false)"
    ></mat-datepicker>
  </mat-form-field>
</div>
